import { render, staticRenderFns } from "./referralfee.vue?vue&type=template&id=29606c90&scoped=true&"
import script from "./referralfee.vue?vue&type=script&lang=js&"
export * from "./referralfee.vue?vue&type=script&lang=js&"
import style0 from "./referralfee.vue?vue&type=style&index=0&id=29606c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29606c90",
  null
  
)

export default component.exports